var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "global-map-area promo-box no-margin parallax",
      attrs: { "data-stellar-background-ratio": "0.5" },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "content-section description pull-right col-sm-9" },
          [
            _c("div", { staticClass: "table-wrapper hidden-table-sm" }, [
              _c("div", { staticClass: "table-cell" }, [
                _c(
                  "h1",
                  {
                    staticClass: "m-title animated",
                    attrs: { "data-animation-type": "fadeInDown" },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.promotext1[_vm.getCurrentLocale])
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("em", [
                      _vm._v(_vm._s(_vm.promotext2[_vm.getCurrentLocale])),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action-section table-cell" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-large animated sundairsrvcs",
                    attrs: {
                      "data-animation-type": "bounce",
                      "data-animation-delay": "0.5",
                      onclick: "window.location.href = '/services';",
                    },
                  },
                  [_vm._v(_vm._s(_vm.booknowwithus[_vm.getCurrentLocale]))]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-container col-sm-4" }, [
      _c("img", {
        staticClass: "animated",
        attrs: {
          src: "/res/images/shared/familie.png",
          alt: "",
          width: "",
          height: "195",
          "data-animation-type": "fadeInUp",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }